const REFERENCE_ASSETS = require('../reference-assets.js');

module.exports = {
    dai: {
        id: 'dai',
        type: REFERENCE_ASSETS.USD,
        symbol: 'DAI',
        decimals: 1e18,
        address: '0x90Ca507a5D4458a4C6C6249d186b6dCb02a5BCCd',
    },
    usdc: {
        id: 'usdc',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDC',
        decimals: 1e6,
        address: '0xef4229c8c3250C675F21BCefa42f58EfbfF6002a',
    },
    usdt: {
        id: 'usdt',
        type: REFERENCE_ASSETS.USD,
        symbol: 'USDT',
        decimals: 1e6,
        address: '0x88eeC49252c8cbc039DCdB394c0c2BA2f1637EA0',
    },
    celo: {
        id: 'celo',
        type: REFERENCE_ASSETS.CELO,
        symbol: 'CELO',
        decimals: 1e18,
        address: '0x471EcE3750Da237f93B8E339c536989b8978a438',
    },
};
